import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import * as LotActionType from "../constants";
import * as NotifyActionType from "../../Notification/constants";

class HomeOwnerManageLot extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    HomeownerLots: PropTypes.array,
  };

  componentDidMount() {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
      // callbackRedirectToLotDetail: (lotId) => {
      //   this.props.history.push(`lots/${lotId}`);
      // }
    });
    this.props.dispatch({
      type: LotActionType.RESET_LOT_PROFILE,
    });
  }

  /**
   * Lot ids come back from different services with or without dashes,
   * so compare them in a normalized form
   */
  normalizeLotId = (id) =>
    id ? String(id).replace(/-/g, "").toLowerCase() : "";

  onClickNewRFS = (e, item) => {
    e.preventDefault();
    const lotId = item.lot.id;
    this.props.dispatch({
      type: LotActionType.CHECK_HOMEOWNER_LOT_RFS_ASYNC,
      params: [lotId],
      callback: (data) => {
        const lotStatus = data.find(
          (x) => this.normalizeLotId(x.lotId) === this.normalizeLotId(lotId),
        );
        if (lotStatus && lotStatus.hoRFSEnabled) {
          this.props.history.push(`/lot/${lotId}/request/add`);
        } else {
          this.props.dispatch({
            type: NotifyActionType.NOTIFY_ERROR,
            data: "Request for Service is not enabled for this property. Please contact your builder or administrator if you need assistance..",
          });
        }
      },
    });
  };

  renderLotOwners = (lotOwners) => {
    return (
      <React.Fragment>
        <div
          style={{
            marginBottom: 10,
            fontSize: 16,
            fontWeight: 500,
            color: "#4d4d4d",
          }}
        >
          Lots that you own
        </div>
        <ul className="homeowner-manage-lot-list" style={{ marginBottom: 60 }}>
          {lotOwners.map((item) => (
            // No conditional logic needed here, as the list is already filtered
            <li key={item.lot.id}>
              <Link to={`lots/${item.lot.id}`}>
                <span className="lot-record">
                  <span className="lot-name">{item.lot.name}</span>
                  <span className="lot-address">
                    <i className="address-ic fa fa-map-marker" />
                    {item.lot.streetAddress}
                  </span>
                </span>
                <span className="lot-add-rfs">
                  <button
                    className="btn btn-siteone"
                    disabled={!(item.hasHORFS || item.HasHORFS)}
                    onClick={(e) => this.onClickNewRFS(e, item)}
                  >
                    <i className="fa fa-plus" />
                    Request for service
                  </button>
                </span>
                <span className="lot-direct">
                  <i className="direct-ic fa fa-angle-right" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </React.Fragment>
    );
  };

  renderLotTenancies = (tenancies) => {
    return (
      <React.Fragment>
        <div
          style={{
            marginBottom: 10,
            fontSize: 16,
            fontWeight: 500,
            color: "#4d4d4d",
          }}
        >
          Lots that I rent
        </div>
        <ul className="homeowner-manage-lot-list">
          {tenancies.map((item) => {
            return (
              <li key={item.lot.id}>
                <Link to={`lots/${item.lot.id}`}>
                  <span
                    className="lot-record"
                    style={{ width: "96%", padding: "7px 0" }}
                  >
                    <span className="lot-name">{item.lot.name}</span>
                    <span className="lot-address">
                      <i className="address-ic fa fa-map-marker" />
                      {item.lot.streetAddress}
                    </span>
                  </span>
                  <span className="lot-direct">
                    <i className="direct-ic fa fa-angle-right" />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </React.Fragment>
    );
  };

  render() {
    const { HomeownerLots } = this.props;

    // 1. Filter the lots based on all criteria first
    const lotOwners = HomeownerLots.filter(
      (x) => x.owner && x.owner.status === 1 && x.lotStatus === true,
    );
    const tenancies = HomeownerLots.filter(
      (x) => x.tenancy && x.tenancy.status === 1,
    );
    return (
      <div className="homeowner-manage-lot-wrapper" style={{ margin: "20px" }}>
        <div className="">
          <div className=" homeowner-manage-lot clearfix">
            {lotOwners.length > 0 && this.renderLotOwners(lotOwners)}
            {tenancies.length > 0 && this.renderLotTenancies(tenancies)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    HomeownerLots: state.LotStore.HomeownerLots,
  };
};

export default connect(mapStateToProps)(HomeOwnerManageLot);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-list.js